module.exports = __webpack_public_path__ + "static/media/the-convention-centre-dublin.5e47075d.png";